import React from 'react';
import { Fragment } from 'react';
import { useContext } from 'react';
import { HelpCenterContext } from './Context/HelpCenterContext';
import { helpCenterContent } from "./Data"

export const SearchComponent = () => {
    const { state, dispatch } = useContext(HelpCenterContext)

    const handleSearch = (event) => {
        const Articles = []
        const Videos = []

        // filter helpCenterContent based on search keyword
        // the text, description, and tag of Articles and Videos will be searched
        const content = helpCenterContent.filter(item => {
            return item.Article.filter(article => {
                return article.text.toLowerCase().includes(event.target.value.toLowerCase()) ||
                    article.description.toLowerCase().includes(event.target.value.toLowerCase()) ||
                    article.tag.toLowerCase().includes(event.target.value.toLowerCase())
            }).length > 0 || item.Video.filter(video => {
                return video.text.toLowerCase().includes(event.target.value.toLowerCase()) ||
                    video.description.toLowerCase().includes(event.target.value.toLowerCase()) ||
                    video.tag.toLowerCase().includes(event.target.value.toLowerCase())
            }).length > 0
        })

        for (let item of content) {
            for (let article of item.Article) {
                //filter out articles that doesn't includes event.target.value
                if (article.text.toLowerCase().includes(event.target.value.toLowerCase()) ||
                    article.description.toLowerCase().includes(event.target.value.toLowerCase()) ||
                    article.tag.toLowerCase().includes(event.target.value.toLowerCase())
                ) {
                    Articles.push(article)
                }
            }
            for (let video of item.Video) {
                debugger
                //filter out video that doesn't includes event.target.value
                if (video.text.toLowerCase().includes(event.target.value.toLowerCase()) ||
                    video.description.toLowerCase().includes(event.target.value.toLowerCase()) ||
                    video.tag.toLowerCase().includes(event.target.value.toLowerCase())
                ) {
                    Videos.push(video)
                    //filer video that order 1 and 3
                    // if (video.order === 1 || video.order === 3) {
                    // }
                }
            }
        }
        let data = [...Articles, ...Videos]
        const uniqueSet = new Set(data);
        data = [...uniqueSet];
        dispatch({
            type: "SET_SEARCH_KEYWORD",
            payload: {
                searchKeyword: event.target.value,
                searchResult: data
            }
        })
    }
    return (
        <Fragment>
            {(!state.showDetailComponent && !state.showContactUsOptions) &&
                <div className="top-section">
                    <strong className="font-size-2">How can we help?</strong>
                    <input
                        autoFocus={true}
                        onChange={handleSearch}
                        value={state.searchKeyword}
                        type="text"
                        placeholder="&#xf002; &nbsp; Search topics in our resources"
                        className="d-block w-100 mt-2 form-control unicode"
                    />
                </div>
            }
        </Fragment>
    )
}